const host = '//v.17173.com/vapi'
export const poster = '//ue.17173cdn.com/a/v/index/2019/img/poster.jpg'

export const urls = {
  search: `${host}/search`,
  playContainer: `${host}/playContainer`,
  playNum: '',
  playInfo: `${host}/playInfo`,
  container: `${host}/container`,
  log: `//v.17173.com/log`
}

export const PAGE_SIZE = 20
